'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

var _effects = require('redux-saga/effects');

var _reactSpectraEditor = require('@complat/react-spectra-editor');

var _action_type = require('../constants/action_type');

var _util_file = require('../utils/util_file');

var _fetcher_file = require('../fetchers/fetcher_file');

var _fetcher_file2 = _interopRequireDefault(_fetcher_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(analysisFile),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(convertFile),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(saveFile),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(refreshFile);

function analysisFile(action) {
  var payload, file, isValidExt, isValidSize;
  return regeneratorRuntime.wrap(function analysisFile$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = action.payload;
          file = payload.file;
          isValidExt = (0, _util_file.VerifyJcampExt)(file) || (0, _util_file.VerifyMsExt)(file);
          isValidSize = (0, _util_file.VerifySize)(file);

          if (!(isValidExt && isValidSize)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _action_type.FILE.ADD_DONE,
            payload: payload
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _action_type.FILE.ADD_FAIL,
            payload: payload
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked);
}

var getFileSrc = function getFileSrc(state) {
  return state.file.src;
};

var getMolMass = function getMolMass(state) {
  return state.mol.mass;
};

var getMolSrc = function getMolSrc(state) {
  return state.mol.src;
};

function convertFile(action) {
  var payload, file, mass, mol, rsp, jcamp, img, listJcamps, origData, jcampData, dst, jcampList, dstList;
  return regeneratorRuntime.wrap(function convertFile$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = action.payload;
          _context2.t0 = payload.file;

          if (_context2.t0) {
            _context2.next = 6;
            break;
          }

          _context2.next = 5;
          return (0, _effects.select)(getFileSrc);

        case 5:
          _context2.t0 = _context2.sent;

        case 6:
          file = _context2.t0;
          _context2.t1 = payload.file;

          if (_context2.t1) {
            _context2.next = 12;
            break;
          }

          _context2.next = 11;
          return (0, _effects.select)(getMolMass);

        case 11:
          _context2.t1 = _context2.sent;

        case 12:
          mass = _context2.t1;
          _context2.next = 15;
          return (0, _effects.select)(getMolSrc);

        case 15:
          mol = _context2.sent;
          _context2.next = 18;
          return (0, _effects.call)(_fetcher_file2.default.convertFile, { file: file, mass: mass, mol: mol });

        case 18:
          rsp = _context2.sent;

          if (!(rsp && rsp.status)) {
            _context2.next = 40;
            break;
          }

          jcamp = rsp.jcamp, img = rsp.img, listJcamps = rsp.listJcamps;

          if (!jcamp) {
            _context2.next = 29;
            break;
          }

          origData = _base2.default.decode(jcamp);
          jcampData = _reactSpectraEditor.FN.ExtractJcamp(origData);
          dst = new File([origData], 'dst.jcamp');
          _context2.next = 27;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_DONE,
            payload: Object.assign({}, {
              file: file, img: img, jcamp: jcampData, dst: dst
            })
          });

        case 27:
          _context2.next = 38;
          break;

        case 29:
          if (!listJcamps) {
            _context2.next = 36;
            break;
          }

          jcampList = listJcamps.map(function (itemJcamp) {
            var origData = _base2.default.decode(itemJcamp);
            var jcampData = _reactSpectraEditor.FN.ExtractJcamp(origData);
            return jcampData;
          });
          dstList = listJcamps.map(function (itemJcamp, idx) {
            var origData = _base2.default.decode(itemJcamp);
            var dst = new File([origData], 'dst_' + idx + '.jcamp');
            return dst;
          });
          _context2.next = 34;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_DONE,
            payload: Object.assign({}, {
              file: file, jcampList: jcampList, dstList: dstList
            })
          });

        case 34:
          _context2.next = 38;
          break;

        case 36:
          _context2.next = 38;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_FAIL,
            payload: payload
          });

        case 38:
          _context2.next = 42;
          break;

        case 40:
          _context2.next = 42;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_FAIL,
            payload: payload
          });

        case 42:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2);
}

var getFileDst = function getFileDst(state) {
  return state.file.dst;
};

var getListFileDst = function getListFileDst(state) {
  return state.file.dstList;
};

function saveFile(action) {
  var payload, src, dst, mol, dstList, name, filename, target;
  return regeneratorRuntime.wrap(function saveFile$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = action.payload;
          _context3.next = 3;
          return (0, _effects.select)(getFileSrc);

        case 3:
          src = _context3.sent;
          _context3.next = 6;
          return (0, _effects.select)(getFileDst);

        case 6:
          dst = _context3.sent;
          _context3.next = 9;
          return (0, _effects.select)(getMolSrc);

        case 9:
          mol = _context3.sent;
          _context3.next = 12;
          return (0, _effects.select)(getListFileDst);

        case 12:
          dstList = _context3.sent;
          name = src.name;
          filename = name.split('.').slice(0, -1).join('.');
          target = Object.assign({}, payload, {
            src: src, dst: dst, filename: filename, mol: mol, dstList: dstList
          });
          _context3.next = 18;
          return (0, _effects.call)(_fetcher_file2.default.saveFile, target);

        case 18:
          _context3.next = 20;
          return (0, _effects.put)({
            type: _action_type.FILE.SAVE_DONE
          });

        case 20:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3);
}

function refreshFile(action) {
  var payload, src, dst, mol, name, filename, target, rsp, jcamp, img, origData, jcampData, refreshedDst;
  return regeneratorRuntime.wrap(function refreshFile$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          // similar to saveFile
          payload = action.payload;
          _context4.next = 3;
          return (0, _effects.select)(getFileSrc);

        case 3:
          src = _context4.sent;
          _context4.next = 6;
          return (0, _effects.select)(getFileDst);

        case 6:
          dst = _context4.sent;
          _context4.next = 9;
          return (0, _effects.select)(getMolSrc);

        case 9:
          mol = _context4.sent;
          name = src.name;
          filename = name.split('.').slice(0, -1).join('.');
          target = Object.assign({}, payload, {
            src: src, dst: dst, filename: filename, mol: mol
          });

          // similar to convertFile

          _context4.next = 15;
          return (0, _effects.call)(_fetcher_file2.default.refreshFile, target);

        case 15:
          rsp = _context4.sent;

          if (!(rsp && rsp.status)) {
            _context4.next = 25;
            break;
          }

          jcamp = rsp.jcamp, img = rsp.img;
          origData = _base2.default.decode(jcamp);
          jcampData = _reactSpectraEditor.FN.ExtractJcamp(origData);
          refreshedDst = new File([origData], 'dst.jcamp');
          _context4.next = 23;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_DONE,
            payload: Object.assign({}, {
              file: src, img: img, jcamp: jcampData, dst: refreshedDst
            })
          });

        case 23:
          _context4.next = 27;
          break;

        case 25:
          _context4.next = 27;
          return (0, _effects.put)({
            type: _action_type.FILE.CONVERT_FAIL,
            payload: payload
          });

        case 27:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4);
}

var fileSagas = [(0, _effects.takeEvery)(_action_type.FILE.ADD_INIT, analysisFile), (0, _effects.takeEvery)(_action_type.FORM.SUBMIT, convertFile), (0, _effects.takeEvery)(_action_type.FILE.SAVE_INIT, saveFile), (0, _effects.takeEvery)(_action_type.FILE.REFRESH_INIT, refreshFile)];

exports.default = fileSagas;